<div *ngIf='records != null' class="rm-records-view panel-group">
    <div class='srsListAnchor desktop'></div>
    <div *ngFor='let record of records; let i = index;' id='list_{{record.id}}' class="panel panel-default" style='margin:10px;'>
        <div class="panel-heading">
            <div class="row flex">
                <div class="col-xs-11 flex-11 truncate">
                    <label style="display:inline;"class="control control--checkbox">
                        <!-- [checked] is one-way binding, unlike [(ngModel)] -->
                        <input type="checkbox" [checked]="globalRecordService.globalRecordIdsHash[record.id]" (change)="toggleRecordId(record.id)" [attr.aria-label]="'Select ' + record.title" />                        
                        <div class="control__indicator"></div>
                    </label>
                    <span class="result-title">
                    	<span *ngIf="additionalIcons" class="result-icons-container">
                       	    <span>{{record._index}}. </span>
                        	<i title="{{LOCALIZATION.viewMetadata}}" (click)="viewMetadata(record.id)" class="fa fa-tags" aria-hidden="true"></i>
                        	<i title="{{LOCALIZATION.viewInMap}}" *ngIf="record.geo && mapViewEnabled" (click)="openInMap(record)" class="fa fa-globe-americas" aria-hidden="true"></i>
                        </span>
                        <i title="{{LOCALIZATION.recordInformation}}" *ngIf="record.rm_record_id" (click)="viewRMQuickInfo(record.id)" class="fa fa-folder" aria-hidden="true"></i>
                        <span *ngIf="record.rm_record_id && !record._rm_completed_bool" class="label label-warning tag" style="font-size: 0.75em;">{{LOCALIZATION.incompleteRMRecord}}</span>
                    	<a class='pointMe' [ngClass]="{'visited': visited[record.id],'unvisited' : !visited[record.id]}" (click)="openRecord(record.id)" title="{{ record._decoded['title'] }}">
                    		<span [innerHTML]="record.title"></span>
                    	</a>
                    </span>
                </div>
                <div class="col-xs-1 text-right flex-1">
	                    <div class="dropdown" ngbDropdown>
						  <button ngbDropdownToggle
							  type="button"
							  class="dropdown-toggle dropdown-toggle-fixed btn-xs btn-menu center-block"
							  aria-haspopup="true"
							  aria-expanded="false"
							  [attr.aria-label]="LOCALIZATION.more"
							  title="{{LOCALIZATION.more}}"
							  style="border: 0; background: transparent;">
								<i class="result-nav-icon fa fa-ellipsis-v" aria-hidden="true"></i>
						  </button>								  
	                      <ul class="dropdown-menu dropdown-menu-results custom-drop" ngbDropdownMenu [attr.aria-label]="LOCALIZATION.optionsList" role="menu">
                            <li role="menuitem" *ngIf="record.rm_record_id">
                            	<a title="{{LOCALIZATION.recordInformation}}" (click)="viewRMQuickInfo(record.id)">{{LOCALIZATION.recordInformation}}</a>
                            </li>
                            <li role="menuitem"><a title="{{LOCALIZATION.viewMetadata}}" (click)="viewMetadata(record.id)">{{LOCALIZATION.viewMetadata}}</a></li>
                            <li role="menuitem" *ngIf="userPermissions['ROLE_PRODUCT_DOWNLOAD']">
                            	<a title="{{LOCALIZATION.downloadDocument}}" download class="pointMe accent-color" (click)="downloadDocument(record.id)">{{LOCALIZATION.downloadDocument}}</a>
                            </li>
                            <li role="menuitem" *ngIf="userPermissions['ROLE_PRODUCT_DOWNLOAD']">
                            	<a title="{{LOCALIZATION.downloadMetadata}}" download class="pointMe accent-color" (click)="downloadMetadata(record.id)">{{LOCALIZATION.downloadMetadata}}</a>
                            </li>
                            <li role="menuitem" *ngIf="tagsEnabled && userPermissions['ROLE_PRODUCT_UPDATE']">
                            	<a title="{{LOCALIZATION.viewTags}}" (click)="viewTags(record.id, i)">{{LOCALIZATION.viewTags}}</a>
                            </li>
                            <li role="menuitem" *ngIf="record.rm_record_id">
                            	<a title="{{LOCALIZATION.viewRMRecordAuditLog}}" (click)="viewRecordAudit(record.rm_record_id, i)">{{LOCALIZATION.viewRMRecordAuditLog}}</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="panel-body">
            <div class="row">
				<div class='col-sm-6 col-md-4 col-lg-2 text-center' style="padding-bottom: 10px;">
					<div class="panel-body" style="padding-top:0px">
						<img (click)="openRecord(record.id)" class='img-thumbnail pointMe img-responsive' loading="lazy" [src]="record._thumbs" alt="Thumbnail for {{record.title}}"/>
					</div>
				</div>
				<div class='col-sm-6 col-md-8 col-lg-10'>
		            <div class="row">
		                <div class="col-md-12">
							<span class="list-field-label">{{userFields['rm_folder_id'] ? userFields['rm_folder_id'].displayName : 'Folder'}}:</span>
							<span class="rm-breadcrumb">
	                            <span *ngIf="searchableResultFields.includes('rm_folder_id')" class="repeatable">
	                                <span *ngFor="let val of record.rm_folder_id" class="breadcrumb-value">
	                                  <a class="pointMe" (click)="resultFieldSearch('rm_folder_id', val)" title="{{val}}">{{!val ? "&nbsp" : val}}</a>
									</span>
									<span *ngIf="!record.rm_folder_id">{{LOCALIZATION.none}}</span>
	                            </span>	
	                            <span *ngIf="!searchableResultFields.includes('rm_folder_id')" title="{{record.rm_folder_id}}">{{record.rm_folder_id}}</span>								
							</span>
						</div>
		            </div>
		            <div class="row">
		                <div class="col-md-12">
							<span class="list-field-label">{{userFields['rm_category'] ? userFields['rm_category'].displayName : 'Record Category'}}:</span>
				            <span *ngIf="searchableResultFields.includes('rm_category')" class="repeatable">
				                <span *ngFor="let val of record.rm_category" class="searchable-value">
									<a *ngIf="isValidFieldCollectionValue(record.rm_category, val)" 
									   class="pointMe" 
									   (click)="resultFieldSearch('rm_category', val)" 
									   [title]="val">
									  {{!val ? "&nbsp" : val}}
									</a> 
					                <span *ngIf="!isValidFieldCollectionValue(record.rm_category, val)" [title]="val">
					                    {{val}}
					                </span>
								</span>
				            </span>                                  
				            <span *ngIf="!searchableResultFields.includes('rm_category')" title="{{record.rm_category}}">
				               {{record.rm_category}}
				            </span>
				            <span *ngIf="!record.rm_category">{{LOCALIZATION.none}}</span>								
						</div>
					</div>
					<div class="row">	
		                <div class="col-md-12">
							<span class="list-field-label">{{userFields['rm_subcategory'] ? userFields['rm_subcategory'].displayName : 'Record Sub Category'}}:</span>
				            <span *ngIf="searchableResultFields.includes('rm_subcategory')" class="repeatable">
				                <span *ngFor="let val of record.rm_subcategory" class="searchable-value">
									<a *ngIf="isValidFieldCollectionValue(record.rm_subcategory, val)" 
									   class="pointMe" 
									   (click)="resultFieldSearch('rm_subcategory', val)" 
									   [title]="val">
									  {{!val ? "&nbsp" : val}}
									</a> 
					                <span *ngIf="!isValidFieldCollectionValue(record.rm_subcategory, val)" [title]="val">
					                    {{val}}
					                </span>
								</span>
				            </span>                                  
				            <span *ngIf="!searchableResultFields.includes('rm_subcategory')" title="{{record.rm_subcategory}}">
				               {{record.rm_subcategory}}
				            </span>
				            <span *ngIf="!record.rm_subcategory">{{LOCALIZATION.none}}</span>								
						</div>
		            </div>
		            <div class="row">
		                <div class="col-md-4">
							<span class="list-field-label">{{userFields['rm_filing_date'] ? userFields['rm_filing_date'].displayName : 'Filing date'}}:</span>
							<span title="{{record.rm_filing_date}}">{{record.rm_filing_date}}</span>
						</div>
		                <div class="col-md-4" *ngIf="record.rm_cutoff_date">
							<span class="list-field-label">{{userFields['rm_cutoff_date'] ? userFields['rm_cutoff_date'].displayName : 'Cut Off date'}}:</span>
							<span title="{{record.rm_cutoff_date}}">{{record.rm_cutoff_date}}</span>
						</div>
		            </div>
		            <div class="row">
		                <div class="col-md-4" *ngIf="record.modified_date">
							<span class="list-field-label">{{userFields['modified_date'] ? userFields['modified_date'].displayName : 'Modified on'}}:</span>
							<span title="{{record.modified_date}}">{{record.modified_date}}</span>
						</div>
		                <div class="col-md-4" *ngIf="record.product_size">
							<span class="list-field-label">{{LOCALIZATION.size}}:</span>
							<span title="{{record.product_size}}">{{record.product_size}}</span>
						</div>
		            </div>		            
		            <div class="row">
						<div class="col-md-12">
							<span class="list-field-label">{{userFields['db_description'] ? userFields['db_description'].displayName : 'Description'}}:</span> 
							<span title="{{ record._decoded['db_description'] }}" [innerHTML]="record._trusted['db_description']"></span>
						</div>
		            </div>
		            <div class="row">
		                <div class="col-md-12">
							<span class="list-field-label">{{userFields['rm_record_id'] ? userFields['rm_record_id'].displayName : 'Record ID'}}:</span>
							<span title="{{record.rm_record_id}}">{{record.rm_record_id}}</span>
						</div>
		            </div>
		            <div class="row" *ngIf="record.rm_record_id && userPermissions['ROLE_RECORDS_MANAGEMENT_EDIT'] && record._accessLevel > 3">
						<div class="col-sm-6 col-xs-2">
							<span style="margin: 8px 0;display: inline-block;">{{LOCALIZATION.completeRMRecord}}</span>
							<input id="completeRM_{{record.rm_record_id}}"
								 class="toggle-switch-toggle toggle-switch-toggle-round" aria-labelledby="rmLabel"
								 type="checkbox" [(ngModel)]="record._rm_completed_bool" (click)="toggleRecordComplete(record.rm_record_id)">
							<label for="completeRM_{{record.rm_record_id}}"></label>
						</div>
		            </div>
	            </div>
            </div>                                               
        </div>
    </div>
</div>
